import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CircleAlert(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M18 2C9.163 2 2 9.163 2 18s7.163 16 16 16 16-7.163 16-16A16 16 0 0018 2zm0 31C9.716 33 3 26.284 3 18 3 9.716 9.716 3 18 3c8.284 0 15 6.716 15 15-.01 8.28-6.72 14.99-15 15zm-.5-22h1v10h-1V11zm0 12.5h1v1h-1v-1z"></path>
    </IconSvg>
  );
}
